import React, { useState } from "react";
import { AgChartsReact } from "ag-charts-react";

const ChartExample = ({
  dateWiseData = {},
  strokeColor,
}) => {
  const getLastWeekData = (deals) => {
    // const today = new Date(); // enable this if we need to filter for last 7days from FE (By Deva)..
    // const lastWeekStartDate = new Date(today);
    // lastWeekStartDate.setDate(today.getDate() - 7);
    // const dealsInLastWeek = deals && deals.filter(deal => {
    // const dealDate = new Date(deal.date);
    // return dealDate >= lastWeekStartDate && dealDate <= today;
    // });
    const dealsWithNewField = deals.map((deal) => {
      const dealDate = new Date(deal.date);
      const dd = String(dealDate.getDate()).padStart(2, "0");
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthAbbreviation = monthNames[dealDate.getMonth()];
      const formattedDate = `${dd} ${monthAbbreviation}`;
      return {
        ...deal,
        formattedDate,
      };
    });
    return dealsWithNewField;
  };

  const chartText = (data) => {
    const deals = getLastWeekData(data);
    const deal = deals[0];
    const formattedDate = new Date(deal.date).toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  
    const formattedRevenue = new Intl.NumberFormat('en-IN').format(deal.revenue_earned);
    // return 
    //   <div>
    //     <p>${formattedDate}</p>
    //     <p>Seats Booked</p>
    //     <p>${deal.seats_booked}</p>
    //     <p>Revenue Earned</p>
    //     <p>${formattedRevenue}</p>
    //   </div>
    
    return `${formattedDate}\n Seats Booked\n${deal.seats_booked}\n Revenue Earned\n ${formattedRevenue}`;

  }
  const [options, setOptions] = useState({
    data: getLastWeekData(dateWiseData),
    series: [
      {
        type: "line",
        xKey: "formattedDate",
        yKey: "seats_booked",
        // stroke: `${strokeColor}`,
        // fills: [
        //   `linear-gradient(${strokeColor}, ${strokeColor})`,
        // ],
        yName:  chartText(dateWiseData),
     
        // fill: {
        //   gradient: {
        //     stops: [
        //       // { offset: 0, color: `${strokeColor}`, opacity: 1 },
        //       { offset: 1, color: `${strokeColor}`, opacity: 0.5 }, // Adjust gradientColor as needed
        //     ],
        //   },
        // },
        // tooltipEnabled: true,
        // tooltipRenderer: function (params){
        //   const dataPoint = params.datum;
        //   return {
        //     content: `<div>${dataPoint.formattedDate}: ${dataPoint.seats_booked} seats booked</div>`,
        //   };
        // },
        marker: {
          stroke: `${strokeColor}`,
          // fill: `${strokeColor}`,
        },
      },
    ],
    // yAxis: {
    //   autoRange: true,
    //   min: 0, // Adjust as needed
    //   max: 20, 
    // },
    // tooltip: {
    //   enabled: true,
    // },
  });

  return <AgChartsReact options={options} />;
};

export default ChartExample;
